import { CommonModule }              from '@angular/common';
import { NgModule }                  from '@angular/core';
import { IndicateElsterFieldModule } from '@shared/directives/indicate-elster-field/indicate-elster-field.module';
import { LabelComponent }            from '@shared/form-elements/label/label.component';

@NgModule( {
	declarations: [
		LabelComponent
	],
	imports: [
		// Angular
		CommonModule,

		// Shared
		IndicateElsterFieldModule
	],
	exports: [
		LabelComponent
	]
} )
export class LabelModule {}
